import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/Button';

interface DeleteAgentModalProps {
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
  agentName: string;
  isSubmitting?: boolean;
  errorMessage?: string | null;
}

export default function DeleteAgentModal({
  open,
  onClose,
  onDelete,
  agentName,
  isSubmitting = false,
  errorMessage = null,
}: DeleteAgentModalProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) {
          onClose();
        }
      }}
    >
      <DialogContent className="w-[640px] rounded">
        <DialogHeader className="items-start space-y-0 px-lg! py-md!">
          <DialogTitle className="text-base font-bold">エージェントの削除</DialogTitle>
        </DialogHeader>

        <div className="flex flex-col gap-md p-lg">
          {errorMessage && (
            <div className="rounded border border-solid border-danger bg-red-50 p-sm">
              <p className="text-body-sm text-danger">{errorMessage}</p>
            </div>
          )}
          <p className="text-body-sm">
            {agentName}を削除してよろしいですか？この操作は取り消せません。
          </p>
        </div>

        <DialogFooter className="justify-end gap-md px-lg! py-md!">
          <Button color="secondary" size="md" onClick={onClose} disabled={isSubmitting}>
            キャンセル
          </Button>
          <Button color="danger" size="md" onClick={onDelete} disabled={isSubmitting}>
            {isSubmitting ? '削除中...' : '削除'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
